import React, { useContext } from 'react'
const ThemeContext = React.createContext()

export function ThemeProvider({ children, theme = {} }) {
  return <ThemeContext.Provider value={theme} children={children} />
}

export function useTheme() {
  return useContext(ThemeContext)
}
